var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TransactionTemplate',{ref:"customer-invoice",staticClass:"customer-invoice",attrs:{"screenJson":_vm.getScreenJson,"backButtonRoute":_vm.backButtonRoute,"gcPopupConfig":_vm.gcPopupConfig,"paging":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }